<app-dropdown-menu class="level-selection"
    *ngIf="isDropdownVisible"
    (activeSelection)="changeActiveSelection($event)"
    [dropdownType]="LEVEL_SELECTION_DROPDOWN"
    [features]="levels"
    [isDropdownActive]="isDropdownActive"
    matTooltip="Select type of cells"
></app-dropdown-menu>
